<div class="menu">

    <!-- Large background circle -->
    <div class="shape circle-main"></div>

    <!-- Pink organic blobs -->
    <div class="shape p1"></div>
    <div class="shape p2"></div>
    <div class="shape p3"></div>
    <div class="shape p4"></div>
    <div class="shape p5"></div>
    <div class="shape p6"></div>

    <!-- Teal + orange accents -->
    <div class="shape a1"></div>
    <div class="shape a2"></div>

    <div class="menu-brand">
        <div class="logo-card">
            <img src="assets/img/logo.svg" class="menu-logo" alt="op Stoom" />
        </div>
    </div>

    <ul>
        <li [class.active]="isActive('/dashboard')">
            <a (click)="goToDashboard()">
                <span class="material-icons-outlined">dashboard</span>
                <span class="label">{{ "menu.dashboard" | translate }}</span>
            </a>
        </li>
        <li [class.active]="isActive('/tickets')">
            <a (click)="goToTicket()">
                <span class="material-icons-outlined">confirmation_number</span>
                <span class="label">{{ "menu.ticket" | translate }}</span>
            </a>
        </li>
        <li [class.active]="isActive('/branches')">
            <a (click)="goToBranche()">
                <span class="material-icons-outlined">domain</span>
                <span class="label">{{ "menu.branches" | translate }}</span>
            </a>
        </li>
        <li [class.active]="isActive('/departments')">
            <a (click)="goToDepartments()">
                <span class="material-icons-outlined">apartment</span>
                <span class="label">{{ "menu.departments" | translate }}</span>
            </a>
        </li>
        <li [class.active]="isActive('/users')">
            <a (click)="goToUsers()">
                <span class="material-icons-outlined">person</span>
                <span class="label">{{ "menu.users" | translate }}</span>
            </a>
        </li>
        <li [class.active]="isActive('/priority')">
            <a (click)="goToPriority()">
                <span class="material-icons-outlined">flag</span>
                <span class="label">{{ "menu.priority" | translate }}</span>
            </a>
        </li>
        <li [class.active]="isActive('/status')">
            <a (click)="goToStatus()">
                <span class="material-icons-outlined">check_circle</span>
                <span class="label">{{ "menu.status" | translate }}</span>
            </a>
        </li>
    </ul>
</div>
